import * as $ from 'jquery';
import 'bootstrap';
import * as moment from 'moment';


export class studentDashboard{

	dashboardDisplay(): any{
		let _self: any = this;
		
		let $studentEnrichId   =_self.readValueFromCookie('studentEnrichId');
		let $sportsEnrichId   =_self.readValueFromCookie('athleteId');
		let $category   =_self.readValueFromCookie('category');
		if($studentEnrichId || $sportsEnrichId){
			let $passengerDetails:any   = $('[data-booking-passenger-details]');
			let $passengerDetailsIcon:any   = $('[data-booking-passenger-details] .fa-angle-down');
			let $multiCityTrip:any      = $('.multiCityTrip');

			let $passengerDetailsMob:any   = $('[data-mob-booking-passenger-details]');
			let $passengerDetailsIconMob:any   = $('[data-mob-booking-passenger-details] .fa-angle-down');
			let $recentSearchContainer:any   = $('.recent-container');
			let $couponCode:any = $('.couponCode');
			
			$multiCityTrip.addClass("hide");
			$recentSearchContainer.addClass("hide");
			//$couponCode.addClass("hide");
			if (($studentEnrichId != null && $studentEnrichId != "") || (($sportsEnrichId != null || $sportsEnrichId != "") && $category == "Athletes")) {
				$passengerDetailsIcon.addClass("hide");
				$passengerDetails.addClass("passengerlist-disabled");
				$passengerDetailsIconMob.addClass("hide");
				$passengerDetailsMob.addClass("passengerlist-disabled");
			}

			let $mHolidayscontainer: any = $('#mholiday-ibe--container');
			let $mholidaysPassengerDetails: any = $mHolidayscontainer.find('[data-booking-passenger-details]');
			let $mholidaysPassengerDetailsIcon: any = $mHolidayscontainer.find('[data-booking-passenger-details] .fa-angle-down');
			$mholidaysPassengerDetails.removeClass("passengerlist-disabled");
			$mholidaysPassengerDetailsIcon.removeClass("hide");

			let $mHolidayscontainerMob: any = $('#mobile-mholidays--container');
			let $mholidaysPassengerDetailsMob: any = $mHolidayscontainerMob.find('[data-mob-mholidays-passenger-details]');
			let $mholidaysPassengerDetailsIconMob: any = $mHolidayscontainerMob.find('[data-mob-mholidays-passenger-details] .fa-angle-down');
			$mholidaysPassengerDetailsMob.removeClass("passengerlist-disabled");
			$mholidaysPassengerDetailsIconMob.removeClass("hide");


			let $ibeContainer:any   = $('#ibe-form--container');
		
			let inputElArr = $ibeContainer.find('input[type="radio"]');
			for (var i=0, len=inputElArr.length; i<len; i++) {
				$(inputElArr[i]);
			}
			if ($studentEnrichId != null && $studentEnrichId != "") {
				var options = document.querySelectorAll(".cabin-class .selectize-dropdown-content .option");
				var values = $.map(options ,function(option:any) {
					if(option.dataset.value =="CFFFIRST"){
						option.classList.add("hide");
					} 
				});
				_self.clickCabinClassDisable();
			}
			_self.disableRevenu();
		}
	}

	clickTripsDisable():any{	
		let _self = this;
		let addBtn = $('.trip-container');

		addBtn.on('click', function(e:any){	
			_self.disableRevenu();
		})
	}
	
	clickCabinClassDisable():any{	
		let _self = this;
		let addBtn = $('.navbar-nav');

		addBtn.on('click', function(e:any){	
			_self.disableCabinClass();
		})
	}
	disableCabinClass():any {
		var options = document.querySelectorAll(".cabin-class-mob .selectize-dropdown-content .option");
		
		var values = $.map(options ,function(option:any) {
			if(option.dataset.value  =="CFFFIRST"){
				option.classList.add("hide");
			} 
		});
	}
	
	disableRevenu():any {
		var options1 = document.querySelectorAll(".ibe-navigation .redemption-payment-methods .payment-method-options li label");
		var values1 = $.map(options1 ,function(option:any) {
		   if(option.innerText.trim() != "Card / Cash" && option.innerText.trim() != "Flight + Hotel" && option.innerText.trim() != "Hotel"){
				option.classList.add("hide");
		   }
	   });
		var options1 = document.querySelectorAll("#mobile-bookflight--container .redemption-payment-methods .payment-method-options li label");
		var values1 = $.map(options1 ,function(option:any) {
		   if(option.innerText.trim() != "Card / Cash"){
				option.classList.add("hide");
		   }
	   });
		var options2 = document.querySelectorAll("#mobile-mholidays--container .redemption-payment-methods .payment-method-options li label");
		var values2 = $.map(options2, function (option: any) {
			if (option.innerText.trim() != "Flight + Hotel" && option.innerText.trim() != "Hotel") {
				option.classList.add("hide");
			}
		});

	}
    readValueFromCookie(name:string):any {
		var json="";
		var ca = document.cookie.split(';');
		name = name + "=";
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length,c.length);
			};
		}
		return json;
	}
}
export class studentCard{

	studentCardDisplay(): any{
		let _self: any = this;
		let $loginNav:any      = $('.login-nav');
		let $loginNavMob:any      = $('.mobile-enrich-login');
		let $signupNavMob:any      = $('.mobile-enrich-signup');
		let $enrichLoginSucess:any      = $('.enrich-login--success');
		//$enrichLoginSucess.hide();
		$loginNavMob.hide();
		$signupNavMob.hide();
		//$loginNav.hide();
		//let checkId: any = 'false';
		let studentID:string 			= _self.readValueFromCookie('studentId');
		if(studentID!=null && studentID!='' && studentID!='undefined'){
			//checkId="true";
 		let studentName:string 			= _self.readValueFromCookie('studentName');
		let studentMemberSince:string 		= _self.readValueFromCookie('studentMemberSince');
		let studentexpiryDate:string 		= _self.readValueFromCookie('studentExpiryDate');
		studentMemberSince = moment(studentMemberSince).format('MMMM Do YYYY');
		studentexpiryDate  = moment(studentexpiryDate).format('MMMM Do YYYY');
			$(".student-card-image .card--username").text(studentName);
			$(".student-card-image .card--number").text(studentID);
			$("#member_since_date").text(studentMemberSince);
			$("#member_expiry_date").text(studentexpiryDate);
			$("#miles_total").text(_self.readValueFromCookie('enrichMiles'));
		}
		//get MH Athlete values from cookie
		let athleteID:string 			= _self.readValueFromCookie('athleteId');
		if(athleteID!=null && athleteID!='' && athleteID!='undefined'){
			let athleteName:string 			= _self.readValueFromCookie('athleteName');
			let athleteMemberSince:string 		= _self.readValueFromCookie('athleteMemberSince');
			let athleteexpiryDate:string 		= _self.readValueFromCookie('athleteExpiryDate');
			athleteMemberSince = moment(athleteMemberSince).format('MMMM Do YYYY');
			athleteexpiryDate  = moment(athleteexpiryDate).format('MMMM Do YYYY');
			$(".student-card-image .card--username_mhsports").text(athleteName);
			$(".student-card-image .card--number_mhsports").text(athleteID);
			$("#member_since_date_mhsports").text(athleteMemberSince);
			$("#member_expiry_date_mhsports").text(athleteexpiryDate);
			$("#miles_total").text(_self.readValueFromCookie('enrichMiles'));
		}
	}
	
//mobile-bookflight--container

    readValueFromCookie(name:string):any {
		var json="";
		var ca = document.cookie.split(';');
		name = name + "=";
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length,c.length);
			};
		}
		return json;
	}
}


let scope:Element = document.querySelector('.student-dashboard');
if (scope){
	try {
		
		let studentCardForm = new studentCard();
		studentCardForm.studentCardDisplay();
		let dashboardForm = new studentDashboard();
		dashboardForm.dashboardDisplay();
		dashboardForm.clickTripsDisable();
	} catch(e) {console.error(e);}
}